import { AutogenLayoutLoadBoardTruckSearchUsers } from "./autogen/AutogenLayoutLoadBoardTruckSearchUsers";

export class LoadBoardTruckSearchUsers extends AutogenLayoutLoadBoardTruckSearchUsers {
}
